import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-cellphone-mask-type',
  templateUrl: './cellphone-mask-type.component.html',
  styleUrls: ['./cellphone-mask-type.component.css']
})
export class CellphoneMaskTypeComponent extends FieldType {}
